module.exports = __webpack_public_path__ + "r-v3/img/loading_gooroomee_change_type.7545e8fc.png";